import styled, { keyframes } from 'styled-components';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const pulse = keyframes(["0%{background-color:var(--trellis-color-fill-tertiary-default)}50%{background-color:var(--trellis-color-fill-tertiary-subtle)}100%{background-color:var(--trellis-color-fill-tertiary-default)}"]);
const AnimatedBackground = styled.div.withConfig({
  displayName: "FileSkeleton__AnimatedBackground",
  componentId: "ipmsgy-0"
})(["animation:", " 2s ease-in-out infinite;height:100%;width:100%;"], pulse);
const FileSkeleton = () => /*#__PURE__*/_jsx(View, {
  "data-test-id": "file-skeleton",
  display: "inline-block",
  marginBlockStart: "100",
  blockSize: "34px",
  inlineSize: "100%",
  borderRadius: "100",
  overflow: "hidden",
  children: /*#__PURE__*/_jsx(AnimatedBackground, {})
});
export default FileSkeleton;